import { useEffect } from 'react';
import WOW from 'wowjs';
import 'wowjs/css/libs/animate.css';
import { inView } from 'motion';
import MarqueeValues from './MarqueeValues.mjs';
import LocalDate from './utils.js';

export default function Jackpots({ propertyName, allTotal, allJackpots, propertyTotal, propertyJackpots }) {
  const currentDate = new LocalDate();

  useEffect(() => {
    new WOW.WOW({
      boxClass: 'wowIncrementNumber', live: true, callback: function (box) {
        inView(box, ({ target }) => {
          box.style.position = 'absolute';
          box.parentElement.style.position = 'relative';
          const clone = box.cloneNode(true);
          box.parentElement.appendChild(clone);
          clone.style.cssText = 'position: relative; opacity: 0;';
          const value = parseInt(box.textContent.replace(/,/g, '')),
            increment = Math.ceil(value / 100);
          let current = 0;
          const interval = setInterval(() => {
            current += increment;
            if (current >= value) {
              clearInterval(interval);
              current = value;
            }
            box.textContent = current.toLocaleString();
          }, 10);
        });
      },
    }).init();
  }, []);

  return (
    <div className="block-jackpot">
      <div className="totals-wrap bg-red-faceted py-4 py-lg-5-5">
        <div className="container">
          <div className="d-flex flex-column">
            <div className="jackpot-header pb-5-5">
              <h3 className="h2 text-white">Daily Jackpot Totals</h3>
              <span className="label-1 text-white">{currentDate.formattedDate()}</span>
            </div>

            <div className="jackpot-content text-white">
              <div className="row gy-4">

                {propertyName ? (
                  <div className="col-sm-6 text-center text-sm-start">
                    <span className="d-block subhead-1">{propertyName}&rsquo;s Total:</span>
                    <span className="d-block display-1 nowrap">$<span className="wowIncrementNumber">{propertyTotal}</span></span>
                  </div>
                ) : null}

                <div className="col-sm-6 text-center text-sm-start">
                  <span className="d-block subhead-1">Wind Creek&rsquo;s Total:</span>
                  <span className="d-block display-1 nowrap">$<span className="wowIncrementNumber">{allTotal}</span></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="wc-marquee shadow">
        <MarqueeValues jackpots={propertyJackpots ?? allJackpots} />
      </div>
    </div>
  );
}
